import { Link } from "react-router";

export function NotFoundPage() {
	return (
		<div className="min-h-screen flex flex-col bg-background">
			<div className="flex-1 flex items-center justify-center">
				<div className="max-w-sm w-full p-6 bg-card text-card-foreground rounded-lg shadow">
					<h1 className="text-xl font-semibold mb-2">Page not found</h1>
					<p className="text-sm text-muted-foreground mb-6">
						The page you're looking for doesn't exist or has been moved.
					</p>
					<Link
						to="/"
						className="inline-flex items-center justify-center rounded-md text-sm font-medium h-10 px-4 py-2 bg-primary text-primary-foreground hover:bg-primary/90 w-full"
					>
						Go home
					</Link>
				</div>
			</div>
		</div>
	);
}
